import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { StateSdk } from '../sdks/state.sdk';
import { AppStore } from '@store/legacy/app.store';

/**
 * Global application management. Responsible for state related operations present on all pages.
 */
@Injectable({
	providedIn: 'root'
})
export class ExperienceManager {
	public state$: Observable<ExperienceState>;
	private stateSource: BehaviorSubject<ExperienceState> = new BehaviorSubject<ExperienceState>(null);

	constructor(
		private stateSdk: StateSdk,
		private appStore: AppStore
	) {
		this.state$ = this.stateSource.asObservable();
		this.updateState();
		this.stateSdk.getLoginState().subscribe((viewState) => {
			this.appStore.updateState((x) => {
				x.loginPosterUrl = viewState.loginPosterUrl;
				return x;
			});
		})
	}

	public updateState(state?: ExperienceState) {
		this.stateSource.pipe(take(1)).subscribe((current) => {
			if (!current) {
				current = {} as ExperienceState;
			}
			current.showTopBar = state?.showTopBar ?? true;
			this.stateSource.next(current);
		});
	}
}

interface ExperienceState {
	showTopBar: boolean;
}
